import React from 'react';

import RadioButton from '@/components/atoms/RadioButton';
import Loader from '@/components/atoms/Loader';
import { ModalDeviceList, ModalButton } from '@/components/molecules/SelectPosDevice/SelectPosDevice.style';
import { useGetLocationsQuery } from '@/services/innovorder/marketplace/marketplace.endpoints';
import { useSelector } from 'react-redux';
import { getUserToken } from '@/redux/user';
import { useParams } from 'react-router';
import { withForm } from '@/core/form/withForm';
import { Controller, useFormContext } from 'react-hook-form';
import { EditChannelFormValues } from '../../CreateMenuModal.type';
import { theme } from '@/core/theme';
import { MarketplaceChannelName } from '@/services/innovorder/marketplace/marketplace.type';
import { LoaderContainer } from './SelectMarketplaceStore.style';

const SelectMarketplaceStore: React.FunctionComponent<{ name: string; marketplace: MarketplaceChannelName }> = (
    props,
) => {
    const token = useSelector(getUserToken);
    const { brandId, restaurantId } = useParams<{ brandId: string; restaurantId: string }>();
    const { data, isLoading } = useGetLocationsQuery({ brandId, restaurantId, token, marketplace: props.marketplace });

    const { control } = useFormContext<EditChannelFormValues>();
    if (isLoading) {
        return (
            <LoaderContainer>
                <Loader color={theme.color.primary} size={40} withContainer />
            </LoaderContainer>
        );
    }

    return (
        <>
            <ModalDeviceList>
                {data &&
                    data.map((location) => (
                        <Controller
                            name={'marketplaceStores'}
                            control={control}
                            render={({ field: { onChange, value } }) => {
                                function onStoreChange(target: string) {
                                    const updatedValues = value.filter((storeReference) => storeReference !== target);
                                    if (updatedValues.length === value.length) {
                                        updatedValues.push(target);
                                    }
                                    onChange(updatedValues);
                                }
                                return (
                                    <ModalButton key={`menu-modal-channels-marketplaces-${location.storeReference}`}>
                                        <RadioButton
                                            data-testid={`menu-modal-channels-marketplaces-${location.storeReference}`}
                                            label={location.storeDisplayName || location.storeReference}
                                            checked={value?.some(
                                                (moduleMarketplaceId: string) =>
                                                    moduleMarketplaceId === location.moduleMarketplaceId,
                                            )}
                                            value={location.moduleMarketplaceId}
                                            onChange={onStoreChange}
                                        ></RadioButton>
                                    </ModalButton>
                                );
                            }}
                        />
                    ))}
            </ModalDeviceList>
        </>
    );
};

export default withForm(SelectMarketplaceStore);
